export default __webpack_public_path__ + "static/media/under-armour-sponsor.83651234.png";